export const TEXT_EFFECT_INTENSITY_CONTROL_MIN = 0
export const TEXT_EFFECT_INTENSITY_CONTROL_MAX = 100
export const TEXT_EFFECT_INTENSITY_CONTROL_STEP = 1

export const TEXT_SHADOW_OFFSET_CONTROL_MIN = -100
export const TEXT_SHADOW_OFFSET_CONTROL_MAX = 100
export const TEXT_SHADOW_OFFSET_CONTROL_STEP = 1

export const TEXT_SHADOW_OFFSET_RENDER_PX_MAX = 13
export const TEXT_SHADOW_BLUR_RENDER_PX_MAX = 24
export const TEXT_OUTLINE_WIDTH_RENDER_PX_MAX = 12

export const TEXT_OUTLINE_WIDTH_FIELD_BOUNDS = Object.freeze({
  min: TEXT_EFFECT_INTENSITY_CONTROL_MIN,
  max: TEXT_EFFECT_INTENSITY_CONTROL_MAX,
  step: TEXT_EFFECT_INTENSITY_CONTROL_STEP,
})

export const TEXT_SHADOW_BLUR_FIELD_BOUNDS = Object.freeze({
  min: TEXT_EFFECT_INTENSITY_CONTROL_MIN,
  max: TEXT_EFFECT_INTENSITY_CONTROL_MAX,
  step: TEXT_EFFECT_INTENSITY_CONTROL_STEP,
})

export const TEXT_SHADOW_OFFSET_FIELD_BOUNDS = Object.freeze({
  min: TEXT_SHADOW_OFFSET_CONTROL_MIN,
  max: TEXT_SHADOW_OFFSET_CONTROL_MAX,
  step: TEXT_SHADOW_OFFSET_CONTROL_STEP,
})

const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

const finiteNumber = (value, fallback = 0) => {
  const next = Number(value)
  return Number.isFinite(next) ? next : fallback
}

const controlToPx = (value, controlMax, renderPxMax) =>
  (value / controlMax) * renderPxMax

export const isTextShadowOffsetProp = (prop) =>
  prop === 'effect.shadowOffsetX' || prop === 'effect.shadowOffsetY'

export const isTextShadowBlurProp = (prop) => prop === 'effect.shadowBlur'

export const isTextOutlineWidthProp = (prop) => prop === 'effect.outlineWidth'

export const isTextNormalizedEffectControlProp = (prop) =>
  isTextShadowOffsetProp(prop) || isTextShadowBlurProp(prop) || isTextOutlineWidthProp(prop)

export function normalizeTextShadowOffsetControl(value, fallback = 0) {
  return clamp(
    finiteNumber(value, fallback),
    TEXT_SHADOW_OFFSET_CONTROL_MIN,
    TEXT_SHADOW_OFFSET_CONTROL_MAX
  )
}

export function normalizeTextShadowBlurControl(value, fallback = 0) {
  return clamp(
    finiteNumber(value, fallback),
    TEXT_EFFECT_INTENSITY_CONTROL_MIN,
    TEXT_EFFECT_INTENSITY_CONTROL_MAX
  )
}

export function normalizeTextOutlineWidthControl(value, fallback = 0) {
  return clamp(
    finiteNumber(value, fallback),
    TEXT_EFFECT_INTENSITY_CONTROL_MIN,
    TEXT_EFFECT_INTENSITY_CONTROL_MAX
  )
}

export function normalizeTextEffectControl(prop, value, fallback = 0) {
  if (isTextShadowOffsetProp(prop)) return normalizeTextShadowOffsetControl(value, fallback)
  if (isTextShadowBlurProp(prop)) return normalizeTextShadowBlurControl(value, fallback)
  if (isTextOutlineWidthProp(prop)) return normalizeTextOutlineWidthControl(value, fallback)
  return finiteNumber(value, fallback)
}

export function textShadowOffsetControlToPx(value, fallback = 0) {
  const normalized = normalizeTextShadowOffsetControl(value, fallback)
  return controlToPx(
    normalized,
    TEXT_SHADOW_OFFSET_CONTROL_MAX,
    TEXT_SHADOW_OFFSET_RENDER_PX_MAX
  )
}

export function textShadowBlurControlToPx(value, fallback = 0) {
  const normalized = normalizeTextShadowBlurControl(value, fallback)
  return controlToPx(
    normalized,
    TEXT_EFFECT_INTENSITY_CONTROL_MAX,
    TEXT_SHADOW_BLUR_RENDER_PX_MAX
  )
}

export function textOutlineWidthControlToPx(value, fallback = 0) {
  const normalized = normalizeTextOutlineWidthControl(value, fallback)
  return controlToPx(
    normalized,
    TEXT_EFFECT_INTENSITY_CONTROL_MAX,
    TEXT_OUTLINE_WIDTH_RENDER_PX_MAX
  )
}
